import { CurrentConversationSectionItemContentFeedback } from '../../conversations/models/CurrentConversationSectionItemContentFeedback';
import { ObjectiveAttachment } from './ObjectiveAttachement';

export class PerformanceObjective {
    objectiveId: number;
    studentId: number;
    employeeFirstName: string;
    employeeLastName: string;
    status: number;
    statusName: string;
    statusColor: string;
    name: string;
    description: string;
    createdDate?: Date;
    createdById: number;
    createdByType: number;
    creator: string;
    objectiveRequired: boolean;
    dueDate?: Date;
    closeById: number;
    closeByName: string;
    closeDate?: Date;
    reviewID: number;
    weight: number;
    changed: boolean;
    changedbyId: number;
    chengedBytype: number;
    OriginalObjectiveName: string;
    OriginalObjectiveDescription: string;
    CID?: number;
    newObjAssACK: number;
    newObjMgrReply: number;
    createdByReviewId: number;
    reviewPeriodId: number;
    reviewYear: number;
    allowEmpLinking: boolean;
    allowEmpToViewLink: boolean;
    linkedObjectiveId?: number;
    bonusPlanCategoryId: number;
    achievementPercent: number;
    accountablityId: number;
    roleId: number;
    domain: number;
    deletedById: number;
    deletedByRoleId: number;
    categoryId: number;
    categoryName: string;
    typeId: number;
    typeName: string;
    finalScore: number;
    masterObjectivesId: number;
    kpi: string;
    hasLinkedObjectives: boolean;
    linkedObjectiveName: string;
    domainName: string;
    attachments: ObjectiveAttachment[] = [];
    canUpdate: boolean;
    previousObjectivesCollapse: boolean;
    deletedObjectivesCollapse: boolean;

    // display properties
    selected?: boolean;
    score?: number;
    previousScore?: number;
    feedback?: CurrentConversationSectionItemContentFeedback[];
}